import React, { useEffect, useState } from 'react';
import {
    TextField,
    DialogTitle,
    DialogContentText,
    DialogContent,
    DialogActions,
    Dialog,
    Button,
    Stack,
    InputBase,
    Paper
} from '@mui/material';
import { ValidateEmail } from '../../../Utils';
import toast from 'react-simple-toasts';
import { messages } from '../../../messages';
import { createContact } from '../../../paymentRequest';
import { hideApiLoader, showApiLoader } from '../../../../redux/tool-webjam/actions';
import { useDispatch } from 'react-redux';
import PModalFooter from '../helperComponent/PModalFooter';
import { ct } from '../../../../constant-Utils';


function CreateContact(props) {
    const dispatch = useDispatch();

    const [open, setOpen] = useState(false);
    const [formValues, setFormValues] = useState([{ name: "", email: "" }])

    const [errors, setErrors] = useState([{
        index: 0,
        email: ""
    }])

    const { title, handleContactCreate } = props;

    const handleClose = (type, isRefresh = null) => {
        setOpen(false);
        handleContactCreate(type, isRefresh)
    };

    useEffect(() => {
        setOpen(true);
    }, [])

    let handleInputChange = (e, i) => {
        let newFormValues = [...formValues];
        newFormValues[i]["email"] = e.target.value;
        console.log("new value ", newFormValues)
        setFormValues(newFormValues);
    }

    let addFormFields = () => {
        setFormValues([...formValues, { name: "", email: "" }])
    }

    let removeFormFields = (i) => {
        let newFormValues = [...formValues];
        newFormValues.splice(i, 1);
        setFormValues(newFormValues)
    }

    const handleFormSubmit = () => {
        let data = formValues;
        data = data.map(e => e.email);

        let errorIndex = {};
        let status = 1;
        if (data.length) {
            for (let i = 0; i < data.length; i++) {
                if (!data[i].length) {
                    errorIndex[i] = {
                        index: i,
                        email: ct("messages.emailRequired", "messages")
                    }

                } else if (!ValidateEmail(data[i])) {
                    status = 2; // invalid email
                    errorIndex[i] = {
                        index: i,
                        email: ct("messages.emailInvalid","messages")
                    }
                }
            }
        } else {
            status = 3; // fields are empty
            errorIndex[0] = {
                index: 0,
                email: ct("messages.emailRequired", "messages")
            }
        }

        if (Object.keys(errorIndex).length) {
            setErrors(errorIndex)
        } else {
            dispatch(showApiLoader())
            createContact({
                isBunch: true,
                email: data
            }).then(async res => {
                dispatch(hideApiLoader())
                if (res.status == 1) {
                    let msg = await dynamicMessageLocale(res.data.message);
                    toast(msg)
                    setFormValues([{ name: "", email: "" }])
                    handleClose(false, 1)
                } else if (res.error == 400 || res.error == 406) {
                    if (res.data?.message) {
                        let msg = await dynamicMessageLocale(res.data.message);
                        toast(msg)
                    } else {
                        toast(ct("rta-trmc.dashboard.subscription.failed"))
                    }
                }
            })
        }
    }

    const isEmpty = (value) => {
        return value;
    }

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                className="welcome-modal-pop"
            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    {formValues.map((element, index) => (
                        <Stack direction="row" spacing={2} key={index} sx={{ mb: 2, mt: 2 }}>
                            <TextField
                                label={"Email address "}
                                variant="filled"
                                onChange={(e) => handleInputChange(e, index)}
                                value={isEmpty(element.email)}
                                className="payment-input"
                                sx={{
                                    width: "100%"
                                }}
                                error={errors[index]?.email != undefined && errors[index]?.email != "" ? true : false}
                                helperText={errors[index] != undefined && errors[index]?.email?.length ? errors[index]?.email : ""}
                            />
                            {
                                index == 0
                                    ?
                                    <><Button
                                        size="small"
                                        variant="Outlined"
                                        className='add-sub-icon-c payment-theme-btn-success'
                                        onClick={() => addFormFields()}
                                    >
                                        <i className="fa fa-plus"></i>
                                    </Button></>
                                    :
                                    <><Button
                                        size="small"
                                        variant="Outlined"
                                        className='add-sub-icon-c payment-theme-btn-success'
                                        onClick={() => removeFormFields(index)}
                                    >
                                        <i className="fa fa-minus"></i>
                                    </Button></>
                            }

                        </Stack>

                    ))}

                </DialogContent>
                {/* <DialogActions
                    className='w-100 d-flex justify-content-between'
                    sx={{
                        p : 3,
                        pt:0
                    }}
                >
                    <Button
                        onClick={() => handleFormSubmit()}
                        variant="contained"
                        className='payment-theme-btn-success'
                    
                    >
                        Submit
                    </Button>

                    <Button
                        onClick={() => handleClose(false)}
                        variant="outlined"
                        className='payment-theme-btn-cancel'
                    >Cancel</Button>

                </DialogActions> */}
                <PModalFooter
                    submit={() => handleFormSubmit()}
                    cancel={() => handleClose(false)}
                />
            </Dialog>
        </div>
    );
}

export default CreateContact;
